/**
 * AmazeDeals Theme JavaScript
 * amazedeals-theme.js
 * Vanilla JS — no dependencies required
 */

(function () {
  'use strict';

  /* =========================================================
     Utilities
  ========================================================= */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var priceParts = /\{\{\s*(\w+)\s*\}\}/.exec(format || window.moneyFormat);
    var formatString = format || window.moneyFormat || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (priceParts && priceParts[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* =========================================================
     Announcement Bar
  ========================================================= */

  function initAnnouncementBar() {
    var bar = document.getElementById('announcement-bar');
    if (!bar) return;

    // Announcement bar is rendered in the header section.
    // This handles the dismiss button functionality only.
    var dismissBtn = document.querySelector('.announcement-bar__dismiss');
    if (!dismissBtn) return;

    var barId = bar.dataset.barId || 'main';
    var dismissed = sessionStorage.getItem('announcement_dismissed_' + barId);

    if (dismissed) {
      bar.style.display = 'none';
    }

    dismissBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      sessionStorage.setItem('announcement_dismissed_' + barId, '1');
    });
  }

  /* =========================================================
     Header — Scroll Shadow
  ========================================================= */

  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* =========================================================
     Mobile Menu
  ========================================================= */

  function initMobileMenu() {
    var hamburger = document.getElementById('hamburger-btn');
    var mobileNav = document.getElementById('mobile-nav');
    var mobileOverlay = document.getElementById('mobile-nav-overlay');
    var mobileClose = document.getElementById('mobile-nav-close');

    if (!hamburger || !mobileNav) return;

    function openMenu() {
      mobileNav.classList.add('open');
      if (mobileOverlay) mobileOverlay.classList.add('visible');
      hamburger.classList.add('active');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileNav.classList.remove('open');
      if (mobileOverlay) mobileOverlay.classList.remove('visible');
      hamburger.classList.remove('active');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', function () {
      if (mobileNav.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMenu);
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', closeMenu);
    }
  }

  /* =========================================================
     Toast Notification
  ========================================================= */

  var toastTimeout = null;

  window.showToast = function (message, duration) {
    duration = duration || 3000;
    var toast = document.getElementById('toast-notification');
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add('show');

    if (toastTimeout) clearTimeout(toastTimeout);
    toastTimeout = setTimeout(function () {
      toast.classList.remove('show');
    }, duration);
  };

  /* =========================================================
     Cart AJAX
  ========================================================= */

  var cartRoutes = window.routes || {
    cart_add_url: '/cart/add.js',
    cart_url: '/cart.js',
    cart_change_url: '/cart/change.js'
  };

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  window.addToCart = function (variantId, qty, callback) {
    qty = qty || 1;
    return fetch(cartRoutes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) { throw new Error(err.description || 'Error adding to cart'); });
      }
      return r.json();
    })
    .then(function (item) {
      return fetchCart().then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
        openCartDrawer();
        showToast('Added to cart!');
        if (window.fbq) {
          fbq('track', 'AddToCart', {
            content_ids: [String(item.variant_id || item.id)],
            content_name: item.product_title || item.title,
            content_type: 'product',
            value: (item.price / 100).toFixed(2),
            currency: window.shopCurrency || 'CAD'
          });
        }
        if (typeof callback === 'function') callback(item, cart);
        return cart;
      });
    })
    .catch(function (err) {
      showToast(err.message || 'Could not add to cart.');
    });
  };

  function updateLineItem(key, qty) {
    return fetch(cartRoutes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
  }

  function removeLineItem(key) {
    return updateLineItem(key, 0);
  }

  function updateCartCount(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', count);
    });
  }

  /* =========================================================
     Cart Drawer Render
  ========================================================= */

  window.renderCartDrawer = function (cart) {
    var body = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-drawer-footer');

    if (!body || !footer) return;

    if (!cart || cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">' +
        '<div class="cart-drawer__empty-icon">🛒</div>' +
        '<h3>Your cart is empty</h3>' +
        '<p>Add some mystery boxes to get started!</p>' +
        '<a href="/collections/all" class="btn btn-primary btn-sm" style="margin:0 auto;">Shop Now</a>' +
        '</div>';
      footer.innerHTML = '';
      return;
    }

    var itemsHtml = cart.items.map(function (item) {
      var imageHtml = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '<div style="width:100%;height:100%;background:#f3f4f6;"></div>';

      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';

      return '<div class="cart-drawer__item">' +
        '<div class="cart-drawer__item-image">' + imageHtml + '</div>' +
        '<div class="cart-drawer__item-info">' +
          '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>' +
          variantHtml +
          '<div class="cart-drawer__item-bottom">' +
            '<div class="qty-stepper">' +
              '<button type="button" aria-label="Decrease quantity" data-action="decrease" data-key="' + item.key + '">&#8722;</button>' +
              '<input type="number" min="1" value="' + item.quantity + '" aria-label="Quantity" data-key="' + item.key + '">' +
              '<button type="button" aria-label="Increase quantity" data-action="increase" data-key="' + item.key + '">&#43;</button>' +
            '</div>' +
            '<div class="cart-drawer__item-price">' + formatMoney(item.line_price) + '</div>' +
          '</div>' +
          '<button class="cart-drawer__item-remove" data-key="' + item.key + '" style="margin-top:6px;">Remove</button>' +
        '</div>' +
        '</div>';
    }).join('');

    body.innerHTML = itemsHtml;

    footer.innerHTML =
      '<div class="cart-drawer__subtotal">' +
        '<span class="cart-drawer__subtotal-label">Subtotal</span>' +
        '<span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<div class="cart-drawer__shipping-note">Shipping and taxes calculated at checkout</div>' +
      '<a href="/checkout" class="cart-drawer__checkout-btn">Proceed to Checkout</a>' +
      '<a href="/cart" class="cart-drawer__view-link">View full cart</a>';

    // Bind item interactions
    body.querySelectorAll('.qty-stepper button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var input = body.querySelector('input[data-key="' + key + '"]');
        var current = parseInt(input.value, 10);
        var newQty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        input.value = newQty;
        updateLineItem(key, newQty);
      });
    });

    body.querySelectorAll('.qty-stepper input').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.dataset.key;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        updateLineItem(key, qty);
      });
    });

    body.querySelectorAll('.cart-drawer__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeLineItem(btn.dataset.key);
      });
    });
  };

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* =========================================================
     Cart Drawer Open/Close
  ========================================================= */

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetchCart().then(function (cart) {
      renderCartDrawer(cart);
    });
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    var closeBtn = document.getElementById('cart-drawer-close');
    var overlay = document.getElementById('cart-drawer-overlay');

    if (closeBtn) {
      closeBtn.addEventListener('click', closeCartDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeCartDrawer);
    }

    document.addEventListener('keydown', function (e) {
      var drawer = document.getElementById('cart-drawer');
      if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
        closeCartDrawer();
      }
    });

    // Cart icon trigger
    var cartTriggers = document.querySelectorAll('[data-open-cart]');
    cartTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    // Expose globally
    window.openCartDrawer = openCartDrawer;
    window.closeCartDrawer = closeCartDrawer;
  }

  /* =========================================================
     Product Page — Variant Selection
  ========================================================= */

  function initProductPage() {
    var productForm = document.getElementById('product-form');
    if (!productForm) return;

    var productData = null;
    var productDataEl = document.getElementById('product-json');
    if (productDataEl) {
      try {
        productData = JSON.parse(productDataEl.textContent);
      } catch (e) {
        console.error('Could not parse product JSON', e);
      }
    }

    if (!productData) return;

    var selectedOptions = {};
    var variantIdInput = productForm.querySelector('[name="id"]');

    // Initialize selected options from first available variant
    var firstVariant = productData.variants[0];
    if (firstVariant) {
      productData.options.forEach(function (option, i) {
        selectedOptions[option] = firstVariant.options[i];
      });
    }

    function findVariant() {
      return productData.variants.find(function (v) {
        return productData.options.every(function (option, i) {
          return v.options[i] === selectedOptions[option];
        });
      });
    }

    function updateSelectedVariant(variant) {
      if (!variant) return;

      // Update hidden input
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      // Update price display
      var priceEl = document.querySelector('[data-product-price]');
      var comparePriceEl = document.querySelector('[data-compare-price]');
      var priceBadgeEl = document.querySelector('[data-price-badge]');

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
          var savings = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          if (priceBadgeEl) {
            priceBadgeEl.textContent = 'Save ' + savings + '%';
            priceBadgeEl.style.display = '';
          }
        } else {
          comparePriceEl.style.display = 'none';
          if (priceBadgeEl) priceBadgeEl.style.display = 'none';
        }
      }

      // Update ATC button
      var atcBtn = productForm.querySelector('.add-to-cart-btn');
      if (atcBtn) {
        if (!variant.available) {
          atcBtn.textContent = 'Sold Out';
          atcBtn.disabled = true;
        } else {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
        }
      }

      // Update featured image if variant has image
      if (variant.featured_image) {
        var mainImg = document.getElementById('product-featured-image');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
          mainImg.srcset = '';
        }
      }

      // Update URL
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Variant Pills
    var pills = productForm.querySelectorAll('.variant-pill');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var optionName = pill.dataset.optionName;
        var optionValue = pill.dataset.optionValue;

        selectedOptions[optionName] = optionValue;

        // Update active state for this option group
        productForm.querySelectorAll('.variant-pill[data-option-name="' + optionName + '"]').forEach(function (p) {
          p.classList.remove('selected');
        });
        pill.classList.add('selected');

        var variant = findVariant();
        updateSelectedVariant(variant);
      });
    });

    // Variant Dropdowns
    var selects = productForm.querySelectorAll('.variant-select');
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var optionName = select.dataset.optionName;
        selectedOptions[optionName] = select.value;
        var variant = findVariant();
        updateSelectedVariant(variant);
      });
    });

    // Quantity selector
    var qtyInput = productForm.querySelector('.qty-selector__input');
    var qtyMinus = productForm.querySelector('[data-qty-minus]');
    var qtyPlus = productForm.querySelector('[data-qty-plus]');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10);
        qtyInput.value = val + 1;
      });
    }

    // Add to Cart submission
    var atcBtn = productForm.querySelector('.add-to-cart-btn');
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!variantId) return;

        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';

        addToCart(variantId, qty, function () {
          var variant = findVariant();
          if (variant && variant.available) {
            atcBtn.textContent = 'Add to Cart';
            atcBtn.disabled = false;
          }
        });
      });
    }

    // Product image thumbnails
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var mainImg = document.getElementById('product-featured-image');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }
      });
    });

    // Product description accordion
    var accordionItems = document.querySelectorAll('.product-accordion__item');
    accordionItems.forEach(function (item) {
      var trigger = item.querySelector('.product-accordion__trigger');
      if (trigger) {
        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          accordionItems.forEach(function (i) { i.classList.remove('open'); });
          if (!isOpen) item.classList.add('open');
        });
      }
    });

    // Open first accordion by default
    if (accordionItems.length > 0) {
      accordionItems[0].classList.add('open');
    }

    // Initialize with first variant
    var currentVariant = findVariant();
    if (currentVariant) updateSelectedVariant(currentVariant);
  }

  /* =========================================================
     Cart Page — AJAX Qty Updates
  ========================================================= */

  function initCartPage() {
    var cartContainer = document.getElementById('cart-items-container');
    if (!cartContainer) return;

    cartContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-action]');
      if (!btn) return;

      var action = btn.dataset.cartAction;
      var key = btn.dataset.key;

      if (action === 'remove') {
        btn.closest('tr').style.opacity = '0.5';
        updateLineItem(key, 0).then(function () {
          location.reload();
        });
      }

      if (action === 'decrease' || action === 'increase') {
        var row = btn.closest('tr');
        var input = row.querySelector('input[data-key]');
        var current = parseInt(input.value, 10);
        var newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
        input.value = newQty;
        updateLineItem(key, newQty).then(function () {
          location.reload();
        });
      }
    });

    cartContainer.addEventListener('change', function (e) {
      if (e.target.matches('input[data-key]')) {
        var key = e.target.dataset.key;
        var qty = parseInt(e.target.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        updateLineItem(key, qty).then(function () {
          location.reload();
        });
      }
    });
  }

  /* =========================================================
     Fade-up on scroll (IntersectionObserver)
  ========================================================= */

  function initFadeUp() {
    if (!window.IntersectionObserver) return;

    var elements = document.querySelectorAll('.fade-up');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* =========================================================
     Initialize on DOM ready
  ========================================================= */

  function init() {
    initAnnouncementBar();
    initHeaderScroll();
    initMobileMenu();
    initCartDrawer();
    initProductPage();
    initCartPage();
    initFadeUp();

    // Fetch cart count on load
    fetchCart().then(function (cart) {
      updateCartCount(cart.item_count);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
